import receivingAdress from './receivingAdress'
export default receivingAdress
